








import { Component, Vue, Watch } from "vue-property-decorator"

@Component({
	name: "Default"
})
export default class parts2 extends Vue {
	infoTtile: string = "品牌电器"
	infoAbout: string = "爆款限时限量兑换"

	@Watch("name")
	getWatchValue(newVal: string, oldVal: string) {
		console.log(newVal, oldVal)
	}

	// created() {
	// }

	// mounted() {
	// }
}
